import { Button } from "antd";
import { useDataList } from "shared/components/dataList";
import { FeedTblRow } from "shared/types/assetExporter";
import styles from "./FeedListTitle.module.scss";
import { useState } from "react";
import { useFeedContext } from "./shared/contexts/FeedContext";
import useGetAssetBatches from "./shared/hooks/useGetAssetBatches";

type Props = {
  feedId: string;
  totalFilteredRows: FeedTblRow[];
  setShowSelectAllOption: (showSelectAllOption: boolean) => void;
};

export const FeedListTitle = (props: Props) => {
  const { feedId, totalFilteredRows, setShowSelectAllOption } = props;
  const [dataList, dataListActions] = useDataList<FeedTblRow>();
  const [toggleButton, setToggleButton] = useState(false);
  const { setAssetBatchesForSelectedRows, setEditingAssetBatch, setIsUpdated } =
    useFeedContext();
  const { data: assetBatches } = useGetAssetBatches(feedId, () => {
    setEditingAssetBatch(undefined);
    setIsUpdated(false);
  });
  const onClick = () => {
    if (!toggleButton) {
      dataListActions.setSelectedItems(
        totalFilteredRows.map(row => row.rowIdentifier),
      );
      const assetBatchIds = totalFilteredRows.flatMap(row => row.assetBatches);
      setAssetBatchesForSelectedRows(
        (assetBatches ?? []).filter(
          ({ assetBatchId }) =>
            assetBatchId && assetBatchIds.includes(assetBatchId),
        ),
      );
    } else {
      dataListActions.setSelectedItems([]);
      setShowSelectAllOption(false);
      setAssetBatchesForSelectedRows([]);
    }

    setToggleButton(!toggleButton);
  };

  const selectedCount = toggleButton
    ? totalFilteredRows.length
    : dataList.selectedItems.length;
  return (
    <div className={styles.container}>
      All <b>{selectedCount}</b> rows on this page are selected.&nbsp;
      {!toggleButton ? (
        <Button
          type={"text"}
          className={styles.selectAllButton}
          onClick={onClick}
        >
          Select all {totalFilteredRows.length} rows in this feed
        </Button>
      ) : (
        <Button
          type={"text"}
          className={styles.selectAllButton}
          onClick={onClick}
        >
          Clear selection
        </Button>
      )}
    </div>
  );
};
